import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull';
import NetTermsDropdown from '~/components/NetTermsDropdown/NetTermsDropdown';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export default function NetTermsCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells.draft');
    const { t: commonTexts } = useLocaleKeys('common');
    const onClick = ()=>onOpenModal({
            width: '500px',
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.netTerms(),
                    testId: 'edit-net-terms-modal',
                    content: /*#__PURE__*/ _jsx(NetTermsDropdown, {
                        isReadOnly: false,
                        netTerms: draft.netTerms(),
                        onChange: (netTerms)=>setDraft(draft.setNetTerms(netTerms)),
                        testId: "net-terms-".concat(index, "-dropdown"),
                        dropdownWidth: 220
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-net-terms-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "net-terms-".concat(index),
            children: draft.netTerms() === 0 ? commonTexts.netTerms.uponReceiptOfInvoice() : commonTexts.units.daysCount({
                count: draft.netTerms()
            })
        })
    });
}
